import React, {useEffect, useRef, useState} from "react";
import style from "./front_page_styles.module.css"

import "./microbial_sex_loops/mia_interface";
import {PageTitles, SitePages} from "../SitePages";
import {IFrames, Images, Videos} from "../AssetReferences";
import {ImageLink} from "../components/image_link";
import {BackgroundVideo} from "../components/backgroundVideo";
import {AdditionalElement} from "../components/additional_element";
import AboutPage from "./about_page";
import {AdditionalElementIDs, MicrobeLinkIDs} from "./front_page_data";
import PopupCanvas from "../components/popupCanvas";
import Wobbler from "../components/wobbler";
import UnityIFrame, {Rectum} from "../components/unityIFrame";
import {useNavigate} from "react-router-dom";
import {useTitle} from "../hooks/UseTitle";


export const OPACITY_DIMMED = 0.420;
export const OPACITY_FULL = 1;

export default function FrontPage({}) {
    const [displayAboutPage, setDisplayAboutPage] = useState(false)

    const navigate = useNavigate();
    useTitle(PageTitles.default)
    
    function handlePageOpen(page) {
        navigate(`/${page}`);
    }

    // secret mushroom game

    const [mushroomGameUnlocked, setMushroomGameUnlocked] = useState(false);
    const clickCount = useRef(0);
    let clickCountHandler;

    function RestartTimeout()
    {
        if (clickCountHandler) clearTimeout(clickCountHandler);
        clickCountHandler = setTimeout(() => clickCount.current = 0, 5000)
    }

    function CountClick()
    {
        clickCount.current++;
        if (clickCount.current <= 1) RestartTimeout();
        else if (clickCount.current >= 7) {
            setMushroomGameUnlocked(true);
            RestartTimeout();
        }
    }
    
    return (
        <div id={"front page"}>

            <BackgroundVideo src={Videos.bg2} loadingImage={Videos.bg2_still} loadFullyBeforePlaying={false}/>

            <AboutPage display={displayAboutPage} OnExit={() => setDisplayAboutPage(false)}/>

            {mushroomGameUnlocked ?
                <SecretMushroomGame/> :
            
                <FrontPageLinks
                    onAboutLinkClick={() => setDisplayAboutPage(!displayAboutPage)}
                    handlePageOpen={handlePageOpen}
                    // onSecretCountClick={CountClick} // disabling because something's making it not work
                />
            }
        </div>
    )
}

function SecretMushroomGame()
{   
    return (
        <div id={"SecretMushroomGame Container"} className={style.secret_mushies}
        >
            <UnityIFrame
                id={"SecretMushroomGame_iFrame"}
                iFrame_src={IFrames.Mushies}
                rectum={new Rectum(0, -5, 100, 110) // fills, though trims top and bottom slightly
                    // rectum={new Rectum(0, 10, 100, 80) // "widescreen vibe"
                }/>
        </div>
    )
}




function FrontPageLinks({onAboutLinkClick, handlePageOpen, onSecretCountClick}) {
    const [highlighted, setHighlighted] = useState(null);

    function HandleHover(imgRef, isHovering) {
        // console.log("HandleHover", imgRef, isHovering)
        isHovering ? setHighlighted(imgRef.current) : setHighlighted(null);
    }

  
    return (
        <div id={"front page links"}>
           
            <PopupCanvas
                highlighted={highlighted}
            />

            <AboutLink
                image_default={Images.About}
                image_hover={Images.AboutHover}
                position={{top: 2, left: 85}}
                OnAboutLinkClick={onAboutLinkClick}
                
                highlighted={highlighted}
                
                onHover={HandleHover}
            />

            {/*<div id={"additional elements"} style={{opacity: highlighted ? OPACITY_DIMMED : OPACITY_FULL}}>*/}
            <div id={"additional elements"} >

                <AdditionalElement
                    id={AdditionalElementIDs.BacteriaGrowth}
                    image_url={Images.Bacteria_Growth}
                    className={style.bacteria_growth}
                    position={{left: 5, top: 0}}
                    canvas_reference_image={Images.Bacteria_Growth_CanvasReference}
                    
                    highlighted={highlighted}
                    onHoverStart={(imgRef) => HandleHover(imgRef, true)}
                    onHoverEnd={(imgRef) => HandleHover(imgRef, false)}
                    
                />

                <Wobbler speed={1} intensity={0}>
                    <AdditionalElement
                        id={AdditionalElementIDs.CrazyDots}
                        image_url={Images.Crazy_Dots}
                        className={style.crazy_dots}
                        position={{left: 5, top: 50}}
                        onClick={onSecretCountClick}

                        highlighted={highlighted}
                        onHoverStart={(imgRef) => HandleHover(imgRef, true)}
                        onHoverEnd={(imgRef) => HandleHover(imgRef, false)}
                    />

                </Wobbler>


                <Wobbler speed={0.2} intensity={1}>
                    <AdditionalElement
                        id={AdditionalElementIDs.PurpleSun}
                        image_url={Images.Purple_Sun}
                        className={style.purple_sun}
                        position={{left: 70, top: 40}}

                        highlighted={highlighted}
                        onHoverStart={(imgRef) => HandleHover(imgRef, true)}
                        onHoverEnd={(imgRef) => HandleHover(imgRef, false)}
                    />
                </Wobbler>


                <Wobbler speed={0.8} intensity={0.4}>
                    <AdditionalElement
                        id={AdditionalElementIDs.StretchingCubes}
                        image_url={Images.Stretching_Cubes}
                        className={style.stretching_cubes}
                        position={{left: 55, top: 60}}

                        highlighted={highlighted}
                        onHoverStart={(imgRef) => HandleHover(imgRef, true)}
                        onHoverEnd={(imgRef) => HandleHover(imgRef, false)}
                    />
                </Wobbler>


            </div>


            <div id={"microbe links"}>

                <Wobbler speed={0.4} intensity={1}>
                    <MicrobeLink
                        id={MicrobeLinkIDs.AndeMia}
                        image_url={Images.AndeMia1}
                        position={{top: 5, left: 55}}

                        highlighted={highlighted}

                        onClick={() => handlePageOpen(SitePages.MicrobialSexLoops)}
                        onHover={HandleHover}
                    />

                </Wobbler>


                <Wobbler speed={0.9} intensity={0.05}>

                    <MicrobeLink
                        id={MicrobeLinkIDs.George}
                        image_url={Images.George}
                        position={{left: 33, top: 15}}

                        highlighted={highlighted}

                        onClick={() => handlePageOpen(SitePages.DecaySim)}
                        onHover={HandleHover}

                    />
                </Wobbler>


                <Wobbler speed={0.2} intensity={1}>

                    <MicrobeLink
                        id={MicrobeLinkIDs.ToiBig}
                        image_url={Images.ToiBig}
                        position={{left: 20, top: 55}}

                        highlighted={highlighted}

                        onClick={() => handlePageOpen(SitePages.MicrobialSexVideoComic)}
                        onHover={HandleHover}
                    />

                    <MicrobeLink
                        id={MicrobeLinkIDs.ToiSmall}
                        image_url={Images.ToiSmall}
                        canvas_reference_image={Images.ToiSmall_CanvasReference}
                        
                        position={{left: 31, top: 60}}
                        className={style.littleToi}

                        refresh_canvas_image={true}
                        detect_underfoot={true}

                        highlighted={highlighted}

                        onClick={() => handlePageOpen(SitePages.CybershoreMeditations)}
                        onHover={HandleHover}
                    />
                </Wobbler>


            </div>

        </div>
    )

}


function AboutLink({image_default, image_hover, position, highlighted, onHover,  OnAboutLinkClick, cursorOnHover}) {
    // switches between default image and hover image using the image link's on hover events.
    // could generalise in future but think this is the only occurence of this so far.
    
    const id = "about_link_btn";
    
    const [hover, setHover] = useState(false);
    function HandleHover(imgRef, isHovering) {
        setHover(isHovering);
        onHover(imgRef, isHovering);
    }

    return (
        <div style={{opacity: highlighted ? highlighted.id === id ? OPACITY_FULL : OPACITY_DIMMED : OPACITY_FULL}}>
            <img
                className={style.about_link_hover}
                src={image_hover}
                alt={"link to about page (hover state)"}
                style={{
                    opacity: hover ? 100 : 0,
                    transition: `opacity ${hover ? 100 : 500}ms ease-in-out`,
                    left: position ? `${position.left}vw` : null,
                    top: position ? `${position.top}vh` : null,
                }}
            />

            <ImageLink
                id={id}
                className={style.about_link}
                image_url={image_default}
                alt={"image link to about page"}
                onClick={OnAboutLinkClick}
                onHoverStart={(imgRef) => HandleHover(imgRef, true)}
                onHoverEnd={(imgRef) => HandleHover(imgRef, false)}
                position={position}
                cursor_hover={cursorOnHover}
            />

        </div>
    )
}

export function MicrobeLink({ id, highlighted, image_url, canvas_reference_image, className, position, x_position, y_position, refresh_canvas_image, detect_underfoot, onClick, onHover, cursorOnHover }) {
    function HandleHover(e, isHovering) {
        onHover?.(e, isHovering);
    }

    return (
        <div style={{opacity: highlighted ? highlighted.id === id ? OPACITY_FULL : OPACITY_DIMMED : OPACITY_FULL}}>
            <ImageLink
                id={id ?? null}
                image_url={image_url}
                className={className ? className : style.microbe_link}
                position={position}
                x_position={x_position}
                y_position={y_position}
                refresh_canvas_image={refresh_canvas_image}
                detect_underfoot={detect_underfoot}
                canvas_reference_image={canvas_reference_image}
                onClick={onClick}
                onHoverStart={(imgRef) => HandleHover(imgRef, true)}
                onHoverEnd={(imgRef) => HandleHover(imgRef, false)}
                cursor_hover={cursorOnHover}
            />
        </div>
    )
}

